import { render, staticRenderFns } from "./Automations.vue?vue&type=template&id=0f797193&"
import script from "./Automations.vue?vue&type=script&lang=js&"
export * from "./Automations.vue?vue&type=script&lang=js&"
import style0 from "./Automations.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports